const DELAY = 1

export default {
  data () {
    return {
      mixinIsShowAsync: false,
    }
  },
  methods: {
    mixinAsyncShow (target) {
      this.$watch(
        target,
        function () {
          this.mixinIsShowAsync = false
          setTimeout(() => { this.mixinIsShowAsync = true }, DELAY)
        },
        { immediate: true }
      )
    },
  },
}
